<template>
    <div class="forms-feature__myclimate-checkbox">
        <MyClimateCheckbox v-model="innerValue" />
        <div class="forms-feature__myclimate-checkbox-description">
            <MyClimateDescription />
        </div>        
    </div>
</template>

<script>

    export default {
        model: {
            event: 'change'
        },
        data() {
            return {
                innerValue: null
            }
        },
        watch: {
            value:
            {
                immediate: true,
                handler(newValue) {
                    this.innerValue = newValue;
                }
            },
            innerValue(newValue) {
                this.$emit('change', newValue);
            }
        }
    };
</script>